export const addClassToElementOnScroll = (
  container,
  cssClass,
  scrollPosition
) => {
  const windowHeight = window.innerHeight;
  const elementTop = container.getBoundingClientRect().top;
  const elementVisible = scrollPosition ?? 200;
  if (elementTop < windowHeight - elementVisible) {
    container.classList.add(cssClass);
  }
};

export const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;
  return partiallyVisible
    ? ((top > 0 && top < innerHeight) ||
        (bottom > 0 && bottom < innerHeight)) &&
        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
};
